import { Button } from "@/components/ui/button/button";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { RESERVATION_TYPE_OPTIONS } from "./constants";
import { useHandleSearchActions } from "./hooks";
import { SearchByBasicLayout } from "../../../../_shared";

import type * as Model from "../../../model";
import type { QueryVariables } from "../../../model/use-case/use-search-reservation-list-query-data";

type Props = {
	// 検索条件
	queryVariables: QueryVariables;
	// 予約の検索
	onSearchReservationList: (props: Model.UseCase.SearchReservationListProps) => void;
};

export const BasicSearchActionsComposition = ({ onSearchReservationList, queryVariables }: Props) => {
	const {
		//
		searchState,
		disabled,
		//
		// 予約タイプの変更
		handleChangeReservationType,
		// 日付の変更
		handleChangeFromAndTo,
		// 予約 ID の変更
		handleChangeReservationID,
		// 予約の検索
		handleClickSearchReservationList,
	} = useHandleSearchActions(queryVariables, onSearchReservationList);

	return (
		<SearchByBasicLayout>
			{/* 検索タイプ */}
			<SelectField
				className="min-w-40"
				value={searchState.reservationType}
				options={RESERVATION_TYPE_OPTIONS}
				handleValueChange={(value) =>
					handleChangeReservationType(value as Model.Constants.ReservationTypeForSearchReservationList)
				}
			/>

			{searchState.reservationType !== "reservation_id" ? (
				<>
					{/* 日付での絞り込み */}
					<DatePickerRange
						selected={{
							from: searchState.from,
							to: searchState.to,
						}}
						onSelect={handleChangeFromAndTo}
						showPresetOptions="all-options"
						canSelectPastDate
						className="w-full tablet:w-80"
					/>
				</>
			) : (
				<>
					{/* 予約 ID での絞り込み */}
					<InputTextField value={searchState.reservationID} handleChange={handleChangeReservationID} />
				</>
			)}

			<Button type="button" size="sm" disabled={disabled} onClick={handleClickSearchReservationList}>
				検索
			</Button>
		</SearchByBasicLayout>
	);
};
